// extracted by mini-css-extract-plugin
export default {"itemForm":"testimonial_itemForm__B9X75","btnContainer":"testimonial_btnContainer__Zw3aa"};